import Translation from './translation'

const englishTranslation: Translation = {
  today: 'Today',
  week: 'Week',
  open: 'Open',
  total: 'Total',
  archive: 'Archive',
  course: 'Training Course',
  period: 'Period',
  periodTo: 'to',
  company: 'Company',
  companyPick: 'Please choose your company:',
  continue: 'Continue',
  create: 'Create',
  delete: 'Delete',
  save: 'Save',
  cancel: 'Cancel',
  edit: 'Edit',
  createUser: 'Create',
  done: 'Done',
  markDelete: 'Mark for deletion',
  unmarkDelete: 'Remove deletion mark',
  deactivate: 'Deactivate',
  traineeShipYear: 'Year of Traineeship',
  claimed: 'Claimed',
  back: 'Back',
  on: 'On',
  off: 'Off',
  login: {
    userNotRegisteredError: {
      title: 'Login failed',
      description: 'Unfortunately, you are not yet registered. Please contact the administrator or your trainer.',
    },
  },
  modal: {
    defaultClose: 'Close',
  },
  dashboard: {
    weekend: 'Enjoy your weekend!',
    success: 'You did it!',
    noReport: {
      headline: 'Yeah, looks great!',
      description: "You don't have any reports to do right now — time to work.",
    },
    declinedReportMessageTitle: 'Got report back',
    declinedReportMessage: 'You got your report about {0}{1} back. Changes are requested.',
    reportToArciveAddedSuccessTitle: 'New report in your archive',
    reportToArciveAddedSuccess: 'Your report about {0}{1} was approved by {name} and is now stored in your archive.',
  },
  archivePage: {
    header: 'Archive',
    tableHead: {
      calendarWeek: 'CW',
      date: 'Date',
      department: 'Department',
    },
    searchPlaceholder: 'Search',
    selectAllLabel: 'Select all',
    emptyState: {
      noResult: {
        title: 'Sadly, I didn’t find anything.',
        caption:
          'Please check your search entry and try again. {0} With {1} you can search for a specific calendar week, or with {2} for a time period, or with dep: for a department.',
      },
      initial: {
        title: 'There’s nothing here yet.',
        caption_trainee: 'Your reports appear here as soon as they have been accepted and are then ready for export.',
        caption_trainer: 'You have no trainees; their archives will appear here when available.',
      },
    },
    exportTitle: 'Export started',
    export: 'Shortly you will receive an email with your exported reports.',
    back: 'Back',
  },
  report: {
    title: 'Report for',
    remarks: 'Additional remarks',
    remarksPlaceholder: 'Add additional remarks here...',
    reportSaveSuccess: 'Report saved!',
    textPlaceholder: 'Description',
    export: 'Export PDF',
    handover: 'Hand over this report',
    handoverTitle: 'Hand over report',
    handoverNotificationText: 'Your report was handed over and is now being checked.',
    accept: 'Approve this report',
    decline: 'Hand back to trainee',
    halfDays: 'Half days',
    archived: 'Archived',
    department: {
      title: 'Department',
      departmentAddedTitle: 'Added department',
      departmentAddedText: 'Your department was added and saved successfully.',
      departmentMissingTitle: 'Add department',
      departmentMissingText: 'You have to add a department to hand over your report.',
    },
    incomplete: {
      title: 'Report incomplete',
      description: 'Please make sure all days, your department, and your working hours are filled in.',
    },
    unarchive: 'Unarchive report',
    total: 'Hours per week',
    headingContainer: {
      title: 'Calendar week',
      back: 'Previous',
      forward: 'Next',
    },
    modalTitle: {
      handover: 'Hand over report {0} {1}?',
      accept: 'Approve report {0} {1}?',
      decline: 'Hand back report {0} {1} to trainee?',
      unarchive: 'Unarchive report {0} {1}?',
    },
    modalCopy: {
      handover:
        'After handing your report over, you will not be able to make changes while it is under review by your trainer. If accepted, you will have the option to export it as PDF.',
      accept:
        'After approving the report, your signature will be applied and the trainee will be able to export the report.',
      decline:
        'After handing back the report, the trainee has the option to make changes to the report and hand it over to you again.',
      unarchive:
        'After unarchiving, you will not be able to export the report unless it is approved by your trainer again.',
    },
    comments: {
      addComment: 'Add comment',
      addCommentToEntry: 'Add comment to entry',
    },
    underReview: 'Under review',
  },
  dropdown: {
    help: 'Help',
    logout: 'Logout',
  },
  dayStatus: {
    work: 'Work',
    education: 'Education',
    vacation: 'Vacation',
    sick: 'Sick',
    holiday: 'Holiday',
  },
  weekOverview: {
    week: 'CW',
    finishedDays: 'Days finished',
    commented: 'Commented',
  },
  entryStatus: {
    saveSuccess: 'Entry has been created',
    changeSuccess: 'Entry has been changed',
    deleteSuccess: 'Entry has been deleted',
    saveError: 'Error while saving entry',
    changeError: 'Error while changing entry',
    deleteError: 'Error while deleting entry',
    dayLimitError: 'The entry time exceeds the day limit',
  },
  settings: {
    firstname: 'First name',
    lastname: 'Last name',
    email: 'E-Mail',
    startOfToolusage: 'Start of Lara usage',
    associatedTrainer: 'Associated trainer',
    associatedTrainees: 'Associated trainees',
    notAssociated: 'Not associated yet',
    application: 'Usage',
    apprenticeship: 'Apprenticeship',
    user: 'User',
    trainership: 'Trainer settings',
    contact: 'Contact person',
    trainer: 'Trainer',
    noTrainer: 'You have not been claimed yet',
    saveSuccess: 'Your settings are now up to date.',
    saveSuccessTitle: 'Updated settings',
    saveError: "Your settings couldn't be saved!",
    language: {
      title: 'Language',
      english: 'English',
      german: 'German',
    },
    theme: {
      title: 'Theme',
      system: 'System preference',
      light: 'Light',
      dark: 'Dark',
    },
    other: 'Other',
    notification: 'Get email notifications',
    avatar: {
      label: 'Profile picture',
      title: 'Add a profile picture',
      description: 'Upload your own profile picture.',
      addAvatar: 'Add image',
      removeAvatar: 'Remove image',
      updateAvatar: 'Update image',
      toasts: {
        success: {
          title: 'Image uploaded',
          description: 'Your image was uploaded successfully.',
        },
        errorCompression: {
          title: 'Compression failed',
          description: 'Could not compress the file below 250 KB.',
        },
        errorFileSize: {
          title: 'Upload failed',
          description: 'File was too large. Maximum is 250 KB.',
        },
      },
    },
    signature: {
      title: 'Signature',
      deleteSignature: 'Delete signature',
      addSignature: 'Add signature',
      placeholder: {
        heading: 'Add your signature',
        description: 'To sign your finished documentation, just add your signature.',
      },
      addSuccessTitle: 'Added signature',
      addSuccess: 'Your signature can now be used to automatically sign your reports.',
      deleteSuccessTitle: 'Deleted signature',
      deleteSuccess: 'Your signature can no longer be used to sign documents automatically.',
      modal: {
        title: 'Scan your signature',
        label:
          'Write your signature on a white piece of paper with a black pen and make sure the paper is evenly illuminated so that the contrast between paper and signature is clearly visible.',
        record: 'Record',
        newtry: 'New try',
        error: 'Your browser is apparently not allowed to use your webcam. Please grant access.',
      },
    },
    alexa: {
      headline: 'Your Alexa device',
      linkTitle: 'Add your Alexa device',
      unlinkTitle: 'Remove your Alexa device',
      linkInstructions: 'Log in with your Amazon email to use Lara on your Alexa device.',
      linkButton: 'Login with Amazon',
      unlinkInstructions: 'Remove your Alexa device from your Lara account.',
      unlinkButton: 'Remove Alexa',
      linkSuccess: 'Your Amazon account has been successfully linked with your Lara account.',
      linkError: 'Something went wrong while linking your Amazon account. Please try again later.',
      unlinkSuccess: 'Your Amazon account has been successfully removed.',
      unlinkError: 'Something went wrong while unlinking your Amazon account. Please try again later.',
      loading: 'Your account is being linked. Please wait...',
    },
  },
  onboarding: {
    intro: 'Nice to meet you. Please tell us a bit about your traineeship.',
    hello: 'Hello',
  },
  missing: {
    missingReport: 'The report you are looking for is currently under review or does not exist.',
    missingPage: 'The page you are looking for does not exist.',
    back: 'Return to Dashboard',
  },
  errors: {
    error: 'Error',
    authenticationError: 'Your user could not be found',
    authenticationSubtext: `If you are a trainee, please contact ${ENVIRONMENT.supportMail}.`,
    networkError: 'A network error occurred',
    default: 'An unknown error occurred',
    subtext: `Please try again in a few minutes. If this problem remains, please inform ${ENVIRONMENT.supportMail}.`,
  },
  support: {
    contactTitle: 'Contact',
    contactCopy: 'Report problems or ask questions about your account.',
    faqTitle: 'Questions',
    faqCopy: 'Find useful tips or frequently asked questions about Lara here.',
    questions: {
      signature: {
        question: 'What can I do to make my scanned signature easier to recognize?',
        answer:
          'The best thing to do is to write on a white piece of paper with a thicker pen that is as high‑contrast as possible (e.g. blue/black).',
      },
      name: {
        question: 'What does Lara stand for?',
        answer:
          'Lara got its name from the Swedish word lära [˅læːra], which stands for learning or the “existence” of an apprentice.',
      },
      features: {
        question: 'What can the report‑tool do?',
        answer:
          'With Lara you can write your report books, which are part of the dual vocational training, and hand them over digitally to your trainer. Then they can be checked by him/her and returned to you in the event of change requests or moved directly to your archive and saved.',
      },
      timetable: {
        question: 'Can I upload my schedule?',
        answer: 'You cannot upload your timetable yet, but the feature is already planned!',
      },
      schoolReport: {
        question: 'Can I upload my certificates?',
        answer: 'You cannot upload your certificates yet, but this feature is planned for Lara in the future!',
      },
      handoverMistake: {
        question: 'I sent my report book by mistake. What can I do?',
        answer:
          'Get in touch with your trainer. They can return the report portfolio that has already been sent to you, and you can make changes again.',
      },
      bug: {
        question: 'Who do I contact if I find bugs, have problems or any other suggestions?',
        answer: 'Send us an email to {0} if you have any problems. We will get in touch with you!',
      },
      exportTime: {
        question: 'How long does a bulk export take?',
        answer:
          'In principle, an export does not take long. Nevertheless, plan enough time if you want to export several report books at once.',
      },
      autoSave: {
        question: 'Will my entries be saved automatically?',
        answer:
          'As soon as you have entered an activity (and confirm it with Enter), your entry is automatically saved and you can simply exit the page without having to save manually.',
      },
      aboutUs: {
        question: 'Who is behind Lara?',
        answer:
          'Trainees and dual students from Accenture Song are working on Lara. We manage, design and develop Lara continuously.',
      },
      darkmode: {
        question: 'Does Lara also exist in dark mode?',
        answer: 'Of course! You can choose between a light and dark appearance under {0}.',
        link: 'Settings &gt; Application',
      },
      exportEmail: {
        question: 'How will the report books be delivered to me in the case of a bulk export?',
        answer:
          'Bulk exports are delivered like single exports. However, if a certain number of entries is reached, you will be sent two emails.',
      },
    },
  },
  navigation: {
    reports: 'Reports',
    trainees: 'Trainees',
    trainer: 'Trainer',
    admin: 'Admins',
    dashhboard: 'Dashboard',
    archive: 'Archive',
    settings: 'Settings',
    wiki: 'Wiki',
  },
  trainerReportOverview: {
    todo: '{count} report is still in progress',
    todos: '{count} reports are still in progress',
    upToDate: 'Everything is up to date',
    reportHandoverSuccessTitle: 'Received report',
    reportHandoverSuccess: '{name} has handed over a report.',
    reportCommentSuccessTitle: 'Added comment',
    reportCommentSuccess: 'Your comment was added to the report.',
    reportDeclinedSuccessTitle: 'Handed report back',
    reportDeclinedSuccess: 'You handed the report back and asked for changes.',
    reportToArchiveSuccessTitle: 'Moved report to archive',
    reportToArchiveSuccess: 'You approved the report and it is now stored in the archive.',
  },
  numerals: {
    first: 'First',
    second: 'Second',
    third: 'Third',
    fourth: 'Fourth',
  },
  traineePlaceholders: {
    trainerPlaceholder: 'Trainee is not claimed yet',
    companyPlaceholder: 'Company is not set yet',
    yearPlaceholder: 'Start date is not set yet',
    coursePlaceholder: 'Training course is not set yet',
  },
  noUserPage: {
    title: 'About Lara',
    description: 'Lara enables trainees to write reports intuitively with ease.',
    featureReports: {
      title: 'Write reports',
      description:
        'Always keep an overview and easily write your weekly reports with supportive features such as automated time calculation and dynamic export.',
    },
    featureHandover: {
      title: 'Easy handover',
      description:
        'Reduce the hassle of feedback processes with a simple digital submission to your trainer. Approved documents are automatically signed and can be printed at the end of your traineeship.',
    },
    featureReviews: {
      title: 'Create reviews',
      description:
        'Summarize your experiences after each apprenticeship station with a rich‑text editor that supports media content, syntax highlighting and formulas.',
    },
  },
  trainerReportsPage: {
    emptyState: {
      title: 'There are currently no trainees assigned to you',
      caption: 'You can claim trainees by selecting them on the trainees page.',
    },
  },
  validation: {
    maxLength: 'This field has a maximum length of {0} characters',
    minLength: 'This field has a minimum length of {0} characters',
    required: 'This field is required',
    dateBefore: 'This date has to be before the end date',
    dateAfter: 'This date has to be after the start date',
    startDateOutOfPeriod: 'Start date has to be in the next 5 years',
    endDateOutOfPeriod: 'End date has to be in the next 5 years',
  },
  createTrainee: {
    title: 'New trainee',
    description:
      'Please enter the information of the new trainee here so she/he can log in. You can still change the data later.',
    success: 'The trainee {0} has been created',
  },
  createTrainer: {
    title: 'New trainer',
    description:
      'Please enter the information of the new trainer here so she/he can log in. You can still change the data later.',
    success: 'The trainer {0} has been created',
  },
  createAdmin: {
    title: 'New admin',
    description:
      'Please enter the information of the new admin here so she/he can log in. You can still change the data later.',
    success: 'The admin {0} has been created',
  },
  deleteTrainer: {
    title: 'Deactivate {0}?',
    description:
      'If you delete the user, the account will be deactivated for 24 hours. After that, you will receive an email with the possibility to delete the account.',
    success: 'You will shortly receive an email with the option to delete the user.',
  },
  userDelete: {
    title: 'User deactivated',
    description: 'Shortly, you will receive an email with the option to delete the user.',
  },
  admin: {
    marking: 'Marked for deletion',
  },
}

export default englishTranslation
